import { render, staticRenderFns } from "./BaseReadMore.vue?vue&type=template&id=4b1c423f&scoped=true&"
import script from "./BaseReadMore.vue?vue&type=script&lang=js&"
export * from "./BaseReadMore.vue?vue&type=script&lang=js&"
import style0 from "./BaseReadMore.vue?vue&type=style&index=0&id=4b1c423f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c423f",
  null
  
)

export default component.exports